import { AxiosError } from "axios";

export const handleApiError = (error: unknown) => {
  if (error instanceof AxiosError) {
    const status = error.response?.status;
    switch (status) {
      case 400:
        throw new Error("Bad request. Please check your inputs.");
      case 401:
        throw new Error("Unauthorized. Please log in.");
      case 403:
        throw new Error("Forbidden. You do not have permission.");
      case 404:
        throw new Error("Resource not found.");
      case 500:
        throw new Error("Server error. Try again later.");
      default:
        throw new Error("Something went wrong. Please try again.");
    }
  } else {
    throw new Error("Unexpected error occurred.");
  }
};
